function openfilter(filter) {
  document.querySelector(filter).classList.add("open");
}

function closefilter(filter) {
  document.querySelector(filter).classList.remove("open");
}

function opensortby(sort) {
  document.querySelector(sort).classList.toggle("m-none");
}

let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
let ticking = false;
let headerCache = null;
let mobileSearchCache = null;
let currHeaderBg = '';
let currMobileSearchDisplay = '';
let isLayoutShifting = false;

window.addEventListener('scroll', function () {
  if (!ticking) {
    window.requestAnimationFrame(function () {
      const currentScrollY = window.pageYOffset || document.documentElement.scrollTop;

      // When we toggle display: none/block, the document height changes abruptly,
      // which forces the browser to instantly change currentScrollY.
      // We ignore the logic for 150ms to let the scroll position stabilize.
      if (isLayoutShifting) {
        lastScrollTop = currentScrollY <= 0 ? 0 : currentScrollY;
        ticking = false;
        return;
      }

      if (!headerCache) headerCache = document.querySelector(".latest-header");
      if (!mobileSearchCache) mobileSearchCache = document.querySelector(".mobile-search");

      if (headerCache) {
        if (window.innerWidth <= 749) {
          // Mobile behavior
          if (currentScrollY > 42) {
            if (currHeaderBg !== "#000") {
              headerCache.style.backgroundColor = "#000";
              currHeaderBg = "#000";
            }

            if (mobileSearchCache) {
              if (Math.abs(currentScrollY - lastScrollTop) > 8) { // 8px scroll threshold
                if (currentScrollY > lastScrollTop) {
                  // Scrolling down
                  if (currMobileSearchDisplay !== "none") {
                    mobileSearchCache.style.display = "none";
                    currMobileSearchDisplay = "none";
                    isLayoutShifting = true;
                    setTimeout(() => { isLayoutShifting = false; }, 150);
                  }
                } else {
                  // Scrolling up
                  if (currMobileSearchDisplay !== "block") {
                    mobileSearchCache.style.display = "block";
                    currMobileSearchDisplay = "block";
                    isLayoutShifting = true;
                    setTimeout(() => { isLayoutShifting = false; }, 150);
                  }
                }
              }
            }
          } else {
            // Near Top on Mobile
            if (currHeaderBg !== "transparent") {
              headerCache.style.backgroundColor = "transparent";
              currHeaderBg = "transparent";
            }
            if (mobileSearchCache) {
              if (currMobileSearchDisplay !== "block") {
                mobileSearchCache.style.display = "block";
                currMobileSearchDisplay = "block";
                isLayoutShifting = true;
                setTimeout(() => { isLayoutShifting = false; }, 150);
              }
            }
          }
        } else {
          // Desktop behavior
          if (currentScrollY > 42) {
            if (currHeaderBg !== "#000") {
              headerCache.style.backgroundColor = "#000";
              currHeaderBg = "#000";
            }
          } else {
            if (currHeaderBg !== "transparent") {
              headerCache.style.backgroundColor = "transparent";
              currHeaderBg = "transparent";
            }
          }
        }
      }

      lastScrollTop = currentScrollY <= 0 ? 0 : currentScrollY;
      ticking = false;
    });
    ticking = true;
  }
});




const annousementbar = document.querySelector(".mho-announcement-bar__mobile");

window.addEventListener('scroll', () => {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  if (scrollTop > 0) {
    annousementbar.style.display = "none";
  } else {
    annousementbar.style.display = "block";
  }
});


function miuns(qty) {
  var q = parseInt(document.querySelector(qty).value);
  q--;
  if (q > 0) {
    document.querySelector(qty).value = q
  }
}

function plus(qty) {
  var q = parseInt(document.querySelector(qty).value);
  q++;
  document.querySelector(qty).value = q
}

function openmenu() {
  document.querySelector(".latest-mobile-menu").classList.add("open");
  document.body.classList.add("menu-is-opend");
}

function closemenu() {
  document.querySelector(".latest-mobile-menu").classList.remove("open");
  document.body.classList.remove("menu-is-opend");
}

function togglefootermenu(menu) {
  menu.nextElementSibling.classList.toggle("m-none");
}

var product_bottom_slider = new Swiper(".product-bottom-slider", {
  slidesPerView: 4,
  spaceBetween: 15,
  direction: "vertical",
  mousewheel: true,
  watchSlidesProgress: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    0: {
      slidesPerView: 4,
      spaceBetween: 10,
    },
    750: {
      slidesPerView: 4,
      spaceBetween: 15,
    }
  }
});

var product_top_image = new Swiper(".product-top-image", {
  slidesPerView: 1,
  spaceBetween: 21,
  navigation: {
    nextEl: ".product-top-image-swiper-button-next",
    prevEl: ".product-top-image-swiper-button-prev",
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    type: 'bullets',
  },
  thumbs: {
    swiper: product_bottom_slider,
  },
  observer: true,
  observeParents: true,
  breakpoints: {
    0: {
      slidesPerView: 1,
      spaceBetween: 8,
    },
    768: {
      slidesPerView: 1
    },
  },
  on: {
    init: function () {
      updateSwiperCounterAndProgress(this);
    },
    slideChange: function () {
      updateSwiperCounterAndProgress(this);
    }
  }
});

// Initialize counter and progress bar on page load
if (product_top_image) {
  setTimeout(function () {
    updateSwiperCounterAndProgress(product_top_image);
  }, 100);
}

// Function to update swiper counter and progress bar
function updateSwiperCounterAndProgress(swiper) {
  const currentEl = document.querySelector('.swiper-counter-current');
  const totalEl = document.querySelector('.swiper-counter-total');
  const progressFill = document.querySelector('.swiper-progress-fill');

  if (!swiper || !currentEl || !progressFill) return;

  const currentIndex = swiper.activeIndex + 1;
  const totalSlides = swiper.slides.length;
  const progress = (currentIndex / totalSlides) * 100;

  // Update counter
  currentEl.textContent = currentIndex;
  if (totalEl) {
    totalEl.textContent = totalSlides;
  }

  // Update progress bar
  progressFill.style.width = progress + '%';
}

function changeimage(id) {
  document.querySelectorAll(".product-bottom-slider .swiper-slide").forEach(function (slide, index) {
    if (slide.getAttribute("data-id") == id) {
      // Use the existing global Swiper instances
      // Check if instances exist, if not, they should be initialized globally
      if (!product_bottom_slider || !product_top_image) {
        console.warn("Swiper instances not initialized");
        return;
      }

      // Navigate to the selected slide
      if (index == 0) {
        // Special handling for first slide
        product_bottom_slider.slideTo(1, 0);
        product_bottom_slider.slideTo(0, 0);
        product_top_image.slideTo(1, 0);
        product_top_image.slideTo(0, 0);
      } else {
        // Navigate main image slider first
        product_top_image.slideTo(index, 300);

        // For vertical thumbnail slider, we need to ensure the active slide is visible
        // Calculate the optimal position to show the active slide
        const slidesPerView = product_bottom_slider.params.slidesPerView || 4;
        const totalSlides = product_bottom_slider.slides.length;

        // Calculate target index to ensure the active slide is visible
        let targetThumbnailIndex = index;

        // Check if we're in the last few slides (accounting for slidesPerView)
        const lastVisibleStartIndex = totalSlides - slidesPerView;

        if (index >= lastVisibleStartIndex) {
          // For the last slides, position to show the last slidesPerView slides
          // This ensures the active slide (which is one of the last ones) is visible
          // When index equals or exceeds lastVisibleStartIndex, show from that point
          targetThumbnailIndex = Math.max(0, lastVisibleStartIndex);
        } else if (index >= Math.floor(slidesPerView / 2)) {
          // For middle slides, center the active slide in the viewport
          // For slidesPerView: 4, if index is 5, we want to show slides 3,4,5,6
          targetThumbnailIndex = index - Math.floor(slidesPerView / 2);
        } else {
          // For early slides (index < slidesPerView/2), start from the beginning
          targetThumbnailIndex = 0;
        }

        // Navigate thumbnail slider to show the active slide
        product_bottom_slider.slideTo(targetThumbnailIndex, 300);
      }

      // Double-check and ensure the active slide is visible after a short delay
      setTimeout(function () {
        // Force update to recalculate positions
        product_bottom_slider.update();
        product_bottom_slider.updateSlides();
        product_bottom_slider.updateSlidesClasses();

        // Verify the active slide is visible
        const activeSlide = product_bottom_slider.slides[index];
        if (activeSlide) {
          // Add active class to ensure it's highlighted
          product_bottom_slider.slides.forEach((s, i) => {
            s.classList.toggle('swiper-slide-active', i === index);
            s.classList.toggle('swiper-slide-thumb-active', i === index);
          });

          // Check visibility for vertical slider
          if (product_bottom_slider.direction === 'vertical') {
            const slideRect = activeSlide.getBoundingClientRect();
            const container = product_bottom_slider.el;
            const containerRect = container.getBoundingClientRect();

            // Check if slide is outside the visible area
            const isVisible = slideRect.top >= containerRect.top && slideRect.bottom <= containerRect.bottom;
            const isPartiallyVisible = (slideRect.top < containerRect.bottom && slideRect.bottom > containerRect.top);

            if (!isVisible && !isPartiallyVisible) {
              // Slide is not visible, recalculate position with improved logic
              const slidesPerView = product_bottom_slider.params.slidesPerView || 4;
              const totalSlides = product_bottom_slider.slides.length;

              let targetIndex = index;
              const lastVisibleStartIndex = totalSlides - slidesPerView;

              if (index >= lastVisibleStartIndex) {
                // For the last slides, show the last slidesPerView slides
                targetIndex = Math.max(0, lastVisibleStartIndex);
              } else if (index >= Math.floor(slidesPerView / 2)) {
                // Center the active slide
                targetIndex = index - Math.floor(slidesPerView / 2);
              } else {
                // Start from beginning
                targetIndex = 0;
              }

              product_bottom_slider.slideTo(targetIndex, 300);
            }
          }
        }

        // Update counter and progress bar after slide change
        updateSwiperCounterAndProgress(product_top_image);
      }, 450);
    }
  })
}

product_top_image.on('slideChange', function () {
  document.querySelectorAll('.product-top-image .swiper-pagination-bullet').forEach(bullet => {
    bullet.classList.remove('swiper-pagination-bullet-active');
  });
  if (document.querySelectorAll('.product-top-image .swiper-pagination-bullet')[this.activeIndex]) {
    document.querySelectorAll('.product-top-image .swiper-pagination-bullet')[this.activeIndex].classList.add('swiper-pagination-bullet-active');
  }
  // Update counter and progress bar
  updateSwiperCounterAndProgress(this);
});







window.addEventListener('load', variant_product_info);

// Get actual variant compare at price

// js fixes for price starts here
// Lightweight cache for product JSON to avoid repeated network requests
window.__productDataCache = window.__productDataCache || {};

function variant_product_info() {
  if (typeof frd_variant_id1 === 'undefined') return;

  const product_handle = frd_variant_id1.variant_handle;
  let variant_id = frd_variant_id1.variant_id;

  const mainProductSection = document.querySelector(".new-product-main");
  const frd_pdp_variants = mainProductSection ? mainProductSection.querySelectorAll('.latest-variant-option .latest-option') : [];
  const priceEls = document.querySelectorAll('[frd-price]');
  const compareEls = document.querySelectorAll('[frd-compare-price]');

  function updatePrice(variantId) {
    // Use cached product data if available to avoid slow repeated fetches
    const cacheKey = product_handle;
    let productPromise;

    if (window.__productDataCache[cacheKey]) {
      productPromise = Promise.resolve(window.__productDataCache[cacheKey]);
    } else {
      productPromise = fetch(`/products/${product_handle}.js`)
        .then(res => res.json())
        .then(product => {
          window.__productDataCache[cacheKey] = product;
          return product;
        });
    }

    productPromise.then(product => {
      if (!product || !Array.isArray(product.variants)) return;

      const variant = product.variants.find(v => v.id === variantId);
      if (!variant) return;

      const price = Shopify.formatMoney(variant.price);
      const comparePrice = Shopify.formatMoney(variant.compare_at_price);

      // Update all price elements (desktop and mobile)
      priceEls.forEach(priceEl => {
        priceEl.textContent = price;
      });

      // Update all compare price elements (desktop and mobile)
      compareEls.forEach(compareEl => {
        if (variant.compare_at_price > variant.price) {
          compareEl.textContent = comparePrice;
          compareEl.classList.remove('hidden');
        } else {
          compareEl.classList.add('hidden');
        }
      });

      // Update sales badge percentage for all badges (desktop and mobile)
      const salesBadges = document.querySelectorAll('.sales_badge');
      if (variant.compare_at_price > variant.price) {
        const discountAmount = variant.compare_at_price - variant.price;
        const discountPercentage = Math.round((discountAmount * 100) / variant.compare_at_price);
        salesBadges.forEach(badge => {
          badge.textContent = `-${discountPercentage}%`;
          badge.style.display = '';
        });
      } else {
        salesBadges.forEach(badge => {
          badge.style.display = 'none';
        });
      }
    });
  }

  frd_pdp_variants.forEach(option => {
    option.addEventListener('click', () => {
      const urlParams = new URLSearchParams(window.location.search);
      variant_id = parseInt(urlParams.get('variant')) || variant_id;
      updatePrice(variant_id);
    });
  });

  updatePrice(variant_id);
}
// js fixes for price ends here

// Toggle for verbose variant logs (keep false for cleaner console)
const ENABLE_VERBOSE_VARIANT_LOGS = false;

function variantDebugLog(...args) {
  if (ENABLE_VERBOSE_VARIANT_LOGS) {
    console.log('[VARIANT DEBUG]', ...args);
  }
}

// Focused, high-signal logging of variant state and ATC button
function logVariantSummary(payload) {
  console.log('[VARIANT]', payload);
}


/**
 * Show checking availability loader and hide variants
 */
function showCheckingAvailability() {
  const checkingDiv = document.querySelector('.variant-availability-checking');
  const variantsContainer = document.querySelector('.latest-variant-options');

  if (checkingDiv) {
    checkingDiv.style.display = 'flex';
  }
  if (variantsContainer) {
    variantsContainer.style.display = 'none';
  }
}

/**
 * Hide checking availability loader and show variants
 */
function hideCheckingAvailability() {
  const checkingDiv = document.querySelector('.variant-availability-checking');
  const variantsContainer = document.querySelector('.latest-variant-options');

  if (checkingDiv) {
    checkingDiv.style.display = 'none';
  }
  if (variantsContainer) {
    variantsContainer.style.display = '';
  }
}

/**
 * Sync option buttons to match the current variant
 * This function updates the active state of option buttons based on the selected variant
 * and briefly shows the availability loader while recalculating.
 */
async function syncOptionsToVariant() {
  try {
    // Show loader while recalculating availability (safe if element not present)
    showCheckingAvailability();
  } catch (e) { }

  const masterselect = document.querySelector("#masterselect");
  if (!masterselect) {
    try { hideCheckingAvailability(); } catch (e) { }
    return;
  }

  // Get current variant ID from masterselect or URL
  let variantId = masterselect.value;
  const urlParams = new URLSearchParams(window.location.search);
  const urlVariantId = urlParams.get('variant');

  // Prefer URL variant if available, otherwise use masterselect value
  if (urlVariantId) {
    variantId = urlVariantId;
    masterselect.value = variantId;
  }

  if (!variantId) {
    return;
  }
  // Get all variant options from masterselect
  const masterOptions = document.querySelectorAll("#masterselect option");
  const variants = [];
  let variantTitle = '';

  // Build variants array and find current variant title
  for (let i = 0; i < masterOptions.length; i++) {
    const option = masterOptions[i];
    const title = option.getAttribute("data-index");
    const available = option.getAttribute("data-available") === "true";
    const inventoryQuantity = parseInt(option.getAttribute("data-max")) || 0;

    // Split variant title and only take first 2-3 option values (max 3 options)
    const allOptionValues = title.split(' / ').map(val => val.trim());
    const optionValues = allOptionValues.slice(0, 3); // Only take first 3 options max

    variants.push({
      id: option.value,
      title: title,
      available: available,
      inventoryQuantity: inventoryQuantity,
      optionValues: optionValues
    });

    if (option.value === variantId) {
      variantTitle = title;
    }
  }

  if (!variantTitle) {
    variantDebugLog("ERROR: variantTitle not found for variantId:", variantId);
    try { hideCheckingAvailability(); } catch (e) { }
    return;
  }

  // Find the current variant object
  const currentVariant = variants.find(v => String(v.id) === String(variantId));
  if (!currentVariant) {
    variantDebugLog("ERROR: currentVariant not found for variantId:", variantId);
    try { hideCheckingAvailability(); } catch (e) { }
    return;
  }

  // Get selected options from current variant
  const selectedOptionValues = currentVariant.optionValues || [];

  const availableVariants = [];
  const unavailableVariants = [];

  variants.forEach((variant) => {
    const summary = {
      id: variant.id,
      title: variant.title,
      optionValues: variant.optionValues
    };

    if (variant.available) {
      availableVariants.push(summary);
    } else {
      unavailableVariants.push(summary);
    }
  });

  // Step 2: is current variant available?
  const isCurrentVariantAvailable = availableVariants.some(v => String(v.id) === String(variantId));
  // console.log("[AVAILABILITY] Checking current selected variant...", {
  //   variantId,
  //   variantTitle,
  //   isAvailable: isCurrentVariantAvailable
  // });

  // Step 3: set options and ATC/button state
  try {
    await updateOptionDisableStates({
      availableVariants,
      selectedOptionValues,
      isCurrentVariantAvailable
    });
    setAddToCartState(isCurrentVariantAvailable);
  } catch (error) {
    console.error("Error updating option/ATC states:", error);
  }

  // High-signal log
  logVariantSummary({
    step: 'syncOptionsToVariant',
    variantId,
    variantTitle,
    selectedOptions: selectedOptionValues,
    isAvailable: isCurrentVariantAvailable
  });

  try { hideCheckingAvailability(); } catch (e) { }
  return {
    variantId,
    variantTitle,
    selectedOptions: selectedOptionValues,
    variants,
    availableVariants,
    isCurrentVariantAvailable
  };
}

/**
 * Based on the current selections and available variants, mark each
 * .latest-option element as enabled/disabled via data-disable="false/true".
 *
 * Uses:
 * - data-option-* attributes (e.g., data-option-color, data-option-size) to identify option groups
 * - availableBySelectedOption structure to find related options for each selected option
 * - For each group, enables options that appear in variants with the selected options from OTHER groups
 */
async function updateOptionDisableStates({ availableVariants, selectedOptionValues, isCurrentVariantAvailable }) {
  const startTime = performance.now();
  // console.log("[AVAILABILITY] Setting variant states...");

  if (!availableVariants) {
    // console.log("[AVAILABILITY] No availableVariants provided");
    return;
  }

  // Find option groups (scoped to main product section)
  const mainProductSection = document.querySelector(".new-product-main");
  if (!mainProductSection) {
    // console.log("[AVAILABILITY] Main product section (.new-product-main) not found");
    return;
  }

  const optionGroups = mainProductSection.querySelectorAll(".latest-variant-option");
  // console.log("[AVAILABILITY] Option groups found:", optionGroups.length);
  if (optionGroups.length === 0) {
    // console.log("[AVAILABILITY] No option groups found");
    return;
  }

  // Build group info
  const groups = Array.from(optionGroups).map((group) => {
    const attributes = Array.from(group.attributes);
    const optionAttr = attributes.find(attr => attr.name.startsWith('data-option-'));
    const optionName = optionAttr ? optionAttr.name.replace('data-option-', '') : null;
    const options = group.querySelectorAll(".latest-option");
    const active = group.querySelector(".latest-option.active");
    const selectedValue = active ? active.getAttribute("data-value") : null;
    return { group, optionName, options, selectedValue };
  });

  // For each group, determine which options should be enabled based on availableVariants and current selections
  groups.forEach((groupInfo, groupIndex) => {
    // console.log(`[AVAILABILITY] Processing group "${groupInfo.optionName}"`);

    // Map of other selections (by index)
    const otherSelectionsByIndex = {};
    groups.forEach((g, idx) => {
      if (idx !== groupIndex && g.selectedValue) {
        otherSelectionsByIndex[idx] = g.selectedValue;
      }
    });

    const availableOptionsForThisGroup = new Set();
    availableVariants.forEach((variant) => {
      if (!variant.optionValues || variant.optionValues.length <= groupIndex) return;

      // Check if variant matches all other selected values
      let matches = true;
      for (let otherIdx in otherSelectionsByIndex) {
        if (variant.optionValues[otherIdx] !== otherSelectionsByIndex[otherIdx]) {
          matches = false;
          break;
        }
      }
      if (!matches) return;

      availableOptionsForThisGroup.add(variant.optionValues[groupIndex]);
    });

    // console.log(`[AVAILABILITY] Available options for "${groupInfo.optionName}":`, Array.from(availableOptionsForThisGroup));

    // Set data-disable on each option element
    groupInfo.options.forEach((optionEl) => {
      const optionValue = optionEl.getAttribute("data-value");
      const isEnabled = optionValue && availableOptionsForThisGroup.has(optionValue);
      optionEl.setAttribute("data-disable", isEnabled ? "false" : "true");
    });
  });

  const endTime = performance.now();
  // console.log(`[AVAILABILITY] Variant state update done in ${(endTime - startTime).toFixed(2)}ms. Current variant available: ${isCurrentVariantAvailable}`);
}

function setAddToCartState(isAvailable) {
  const masterselect = document.querySelector("#masterselect");
  const addToCartButton = document.querySelector(".latest-add-to-cart-btn");
  if (!masterselect || !addToCartButton) return;

  const selectedDisabled = !!document.querySelector(
    ".new-product-main .latest-option.active[data-disable='true']"
  );
  const finalAvailable = isAvailable && !selectedDisabled;

  const availabletext = masterselect.getAttribute("data-available-text") || "Add to cart";
  const soldouttext = masterselect.getAttribute("data-solout-text") || masterselect.getAttribute("data-soldout-text") || "Sold out";

  if (finalAvailable) {
    addToCartButton.innerHTML = availabletext;
    addToCartButton.removeAttribute("disabled");
  } else {
    addToCartButton.innerHTML = soldouttext;
    addToCartButton.setAttribute("disabled", "disabled");
  }
}

async function changemaster() {
  var master = document.querySelectorAll("#masterselect option");

  const mainProductSection = document.querySelector(".new-product-main");
  var selected = mainProductSection ? mainProductSection.querySelectorAll(".latest-option.active") : [];
  var variantname = '';

  for (let i = 0; i < selected.length; i++) {
    const element = selected[i].getAttribute("data-value");
    if (i == selected.length - 1) {
      variantname = variantname + element;
    }
    else {
      variantname = variantname + element + ' / ';
    }
  }

  var choosen = false;
  var available = false;
  var id = "";
  var price = "";
  for (let j = 0; j < master.length; j++) {
    const element = master[j].getAttribute("data-index");
    if (element == variantname) {
      id = master[j].getAttribute("value");
      document.querySelector("#masterselect").value = id;
      price = master[j].getAttribute("data-price");
      var choosen = true;
      available = master[j].getAttribute("data-available");
      var imageid = master[j].getAttribute("data-id");
      changeimage(imageid)
    }
  }

  var availabletext = document.querySelector("#masterselect").getAttribute("data-available-text");
  var soldouttext = document.querySelector("#masterselect").getAttribute("data-solout-text");
  var unavailabletext = document.querySelector("#masterselect").getAttribute("data-unavailable-text");
  var price_element;

  const price_elements = document.querySelectorAll('p[frd-price]');
  const addToCartButton = document.querySelector(".latest-add-to-cart-btn");

  if (choosen) {
    setAddToCartState(available == "true");

    // Update all price elements (desktop and mobile)
    price_elements.forEach(price_element => {
      price_element.innerHTML = `${price}`;
      price_element = price_element.innerHTML;
    });
  } else {
    price_element = unavailabletext;
    if (addToCartButton) {
      addToCartButton.innerHTML = unavailabletext;
      addToCartButton.setAttribute("disabled", "disabled");
    }
  }

  logVariantSummary({
    step: 'changemaster',
    variantId: id,
    variantTitle: variantname,
    available,
    addToCart: addToCartButton ? {
      text: addToCartButton.innerHTML,
      disabled: addToCartButton.hasAttribute("disabled")
    } : null
  });

  var nextURL = window.location.pathname + "?variant=" + id;
  window.history.replaceState("", "", nextURL);

  // Sync options after variant change
  try {
    await syncOptionsToVariant();
  } catch (err) {
    console.warn('Error syncing options:', err);
  }
}

// Scope event listeners to main product section only
const mainProductSection = document.querySelector(".new-product-main");
if (mainProductSection) {
  mainProductSection.querySelectorAll(".latest-option").forEach(function (option) {
    option.addEventListener("click", function () {
      this.parentElement.querySelector(".active").classList.remove("active");
      this.classList.add("active");
    if (this.getAttribute("data-disable") === "true") {
      setAddToCartState(false);
    }
      changemaster().catch(err => console.warn('Error in changemaster:', err));
    })
  })
}

function initOptionSyncing() {
  const masterselect = document.querySelector("#masterselect");
  if (masterselect) {
    masterselect.addEventListener('change', function () {
      syncOptionsToVariant().catch(err => console.warn('Error syncing options:', err));
    });
  }
}

// Note: syncOptionsToVariant is no longer triggered on DOM load; it will run on masterselect change or store selection.

var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

document.querySelectorAll(".show_more_collection").forEach(function (btn) {
  btn.addEventListener("click", function () {
    this.classList.add("hide");
    this.parentElement.previousElementSibling.querySelectorAll(".hide").forEach(function (element) {
      element.classList.remove("hide");
    });
  })
})




//  custom cart js starts here

document.addEventListener("DOMContentLoaded", () => {
  const debounce = (fn, wait = 180) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  };

  function logDebug(...args) {
    // comment out to silence
    // console.log(...args);
  }

  /* ---------- Snap-scroll slider init (replaces Swiper) ---------- */
  function initCartRecommendationSwiper() {
    const track = document.querySelector(".cart-rec-track");
    if (!track) return;

    const slider = track.closest(".cart-rec-slider");
    const dotsContainer = slider ? slider.querySelector(".cart-rec-dots") : null;
    const prevBtn = slider ? slider.querySelector(".cart-rec-prev") : null;
    const nextBtn = slider ? slider.querySelector(".cart-rec-next") : null;

    function getVisibleItems() {
      return Array.from(track.querySelectorAll(".cart-recommendation-item")).filter(
        (item) => item.style.display !== "none"
      );
    }

    function getActiveIndex() {
      const scrollLeft = track.scrollLeft;
      const visibleItems = getVisibleItems();
      let closestIndex = 0;
      let closestDist = Infinity;
      visibleItems.forEach((item, i) => {
        const dist = Math.abs(item.offsetLeft - scrollLeft);
        if (dist < closestDist) {
          closestDist = dist;
          closestIndex = i;
        }
      });
      return closestIndex;
    }

    function updateState() {
      const visibleItems = getVisibleItems();
      const activeIndex = getActiveIndex();
      if (dotsContainer) {
        dotsContainer.querySelectorAll(".cart-rec-dot").forEach((dot, i) => {
          dot.classList.toggle("is-active", i === activeIndex);
        });
      }
      if (prevBtn) prevBtn.disabled = activeIndex === 0;
      if (nextBtn) nextBtn.disabled = activeIndex >= visibleItems.length - 1;
    }

    function rebuildDots() {
      if (!dotsContainer) return;
      dotsContainer.innerHTML = "";
      getVisibleItems().forEach((item, i) => {
        const dot = document.createElement("button");
        dot.type = "button";
        dot.className = "cart-rec-dot" + (i === 0 ? " is-active" : "");
        dot.setAttribute("aria-label", "Go to slide " + (i + 1));
        dot.addEventListener("click", () => {
          track.scrollTo({ left: item.offsetLeft, behavior: "smooth" });
        });
        dotsContainer.appendChild(dot);
      });
      updateState();
    }

    if (track.dataset.initialized === "true") {
      rebuildDots();
      return;
    }

    track.dataset.initialized = "true";
    rebuildDots();

    track.addEventListener("scroll", updateState, { passive: true });

    if (prevBtn) {
      prevBtn.addEventListener("click", () => {
        const visibleItems = getVisibleItems();
        const activeIndex = getActiveIndex();
        if (activeIndex > 0) {
          track.scrollTo({ left: visibleItems[activeIndex - 1].offsetLeft, behavior: "smooth" });
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", () => {
        const visibleItems = getVisibleItems();
        const activeIndex = getActiveIndex();
        if (activeIndex < visibleItems.length - 1) {
          track.scrollTo({ left: visibleItems[activeIndex + 1].offsetLeft, behavior: "smooth" });
        }
      });
    }

    logDebug("[DEBUG] Snap-scroll slider initialized");
  }

  /* ---------- utility: read cart item ids from DOM ---------- */
  function getCartItemIdsFromDOM() {
    const cartItems = document.querySelectorAll("[data-cart-item]");
    return Array.from(cartItems).map((node) => String(node.dataset.cartItem)).filter(Boolean);
  }

  /* ---------- Hide recs matching items already in cart ---------- */
  function hideCartRecommendationsForExistingItems() {
    const recProducts = document.querySelectorAll("[data-product-id]");
    if (!recProducts.length) return;

    const cartItemIds = getCartItemIdsFromDOM();
    recProducts.forEach((rec) => {
      const recId = rec.dataset.productId;
      if (!recId) return;
      rec.style.display = cartItemIds.includes(String(recId)) ? "none" : "";
    });

    logDebug("[DEBUG] Hidden recs for cart items:", cartItemIds);
  }

  /* ---------- check variant availability ---------- */
  async function checkVariantAvailability() {
    const buttons = document.querySelectorAll(".add-to-cart-btn");
    if (!buttons.length) return;
    for (const btn of buttons) {
      const variantId = btn.dataset.variantId;
      if (!variantId) continue;
      try {
        const res = await fetch(`/variants/${variantId}.js`);
        if (!res.ok) continue;
        const variantData = await res.json();
        if (!variantData.available || variantData.inventory_quantity <= 0) {
          btn.textContent = "Sold Out";
          btn.disabled = true;
          btn.classList.add("sold-out");
        } else {
          btn.textContent = "Add to Cart";
          btn.disabled = false;
          btn.classList.remove("sold-out");
        }
      } catch (err) {
        console.warn("[DEBUG] Variant availability check failed:", err);
      }
    }
  }

  /* ---------- bind add-to-cart on recs ---------- */
  function bindRecommendationAddToCart() {
    const recButtons = document.querySelectorAll(".add-to-cart-btn");
    if (!recButtons.length) return;

    recButtons.forEach((btn) => {
      if (btn.dataset.bound === "true") return;
      btn.dataset.bound = "true";

      btn.addEventListener("click", async (e) => {
        e.preventDefault();
        const variantId = btn.dataset.variantId;
        if (!variantId || btn.classList.contains("sold-out")) return;
        btn.textContent = "Adding...";
        btn.disabled = true;
        try {
          const addRes = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          });
          if (!addRes.ok) throw await addRes.json();
          const addedItem = await addRes.json();

          const sectionsToRender = ["cart-drawer", "cart-icon-bubble"];
          const sectionsUrl = `/?sections=${sectionsToRender.join(",")}`;
          const sectionsRes = await fetch(sectionsUrl);
          const sectionsJSON = await sectionsRes.json();
          const parsedState = { id: addedItem.id, sections: sectionsJSON };
          const cartDrawer = document.querySelector("cart-drawer");
          if (cartDrawer && typeof cartDrawer.renderContents === "function") {
            cartDrawer.renderContents(parsedState);
            // allow drawer to re-render then update
            setTimeout(() => updateRecommendationState(), 600);
          } else {
            setTimeout(() => updateRecommendationState(), 600);
          }
        } catch (error) {
          console.error("[DEBUG] Add to Cart failed:", error);
        } finally {
          btn.textContent = "Add to Cart";
          btn.disabled = false;
        }
      });
    });
  }

  /* ---------- update helper (debounced) ---------- */
  const updateRecommendationState = debounce(() => {
    initCartRecommendationSwiper();
    bindRecommendationAddToCart();
    checkVariantAvailability();
    hideCartRecommendationsForExistingItems();
  }, 220);

  /* ---------- Temporary, robust MutationObserver (on-demand) ----------
     Behavior:
     - When user clicks plus/minus/remove or changes input, call observeCartChangeOnce()
     - The observer watches document.body for mutations and compares cart item ids before/after.
     - When a difference is detected OR fallback timeout expires, we run updateRecommendationState() and disconnect.
  ---------------------------------------------------------------------*/
  let observeTimeoutId = null;
  function observeCartChangeOnce({ maxWait = 3500, pollInterval = 80 } = {}) {
    // If an observer is already running, don't start another
    if (window.__cartObserverActive) {
      logDebug("[DEBUG] Cart observer already active, skipping new start");
      return;
    }

    const beforeIds = getCartItemIdsFromDOM();
    window.__cartObserverActive = true;
    logDebug("[DEBUG] observeCartChangeOnce started, beforeIds:", beforeIds);

    // MutationObserver will run when DOM nodes change anywhere
    const observer = new MutationObserver((mutations) => {
      // Use a short debounce to avoid noisy rapid mutation callbacks
      clearTimeout(observeTimeoutId);
      observeTimeoutId = setTimeout(() => {
        const afterIds = getCartItemIdsFromDOM();
        // If cart items changed (ids length or content differs), consider update done
        const changed =
          afterIds.length !== beforeIds.length ||
          afterIds.some((id, idx) => id !== beforeIds[idx]) ||
          beforeIds.some((id) => !afterIds.includes(id));

        if (changed) {
          logDebug("[DEBUG] Cart DOM change detected (observer) ->", { beforeIds, afterIds });
          updateRecommendationState();
          cleanup();
        } else {
          // Not changed yet — keep observing
          logDebug("[DEBUG] DOM mutated but cart item ids unchanged");
        }
      }, 120);
    });

    // Observe body subtree — temporary, we disconnect quickly after detection or fallback
    observer.observe(document.body, { childList: true, subtree: true, attributes: false });

    // Fallback: if nothing triggers within maxWait, stop observing and run update once
    const fallback = setTimeout(() => {
      logDebug("[DEBUG] observeCartChangeOnce fallback triggered");
      updateRecommendationState();
      cleanup();
    }, maxWait);

    function cleanup() {
      try {
        observer.disconnect();
      } catch (e) { }
      clearTimeout(fallback);
      clearTimeout(observeTimeoutId);
      window.__cartObserverActive = false;
      logDebug("[DEBUG] observeCartChangeOnce disconnected/cleaned");
    }
  }

  /* ---------- Listeners for user actions (start observer only on these) ---------- */
  function installCartActionDelegation() {
    document.addEventListener("click", (e) => {
      const btn = e.target.closest("button");
      if (!btn) return;

      // plus/minus buttons (most themes use name attributes)
      if (btn.name === "plus" || btn.name === "minus") {
        // start observer to detect theme re-render (robust)
        observeCartChangeOnce();
        return;
      }

      // remove button: handle both button with cart-remove-button class and inside cart-remove-button wrapper
      if (btn.classList.contains("cart-remove-button") || btn.closest("cart-remove-button")) {
        observeCartChangeOnce();
        return;
      }
    });

    // direct numeric input change (user types quantity)
    document.addEventListener("change", (e) => {
      if (e.target && e.target.matches(".quantity__input")) {
        observeCartChangeOnce();
      }
    });
  }

  /* ---------- initial setup ---------- */
  function init() {
    initCartRecommendationSwiper();
    bindRecommendationAddToCart();
    checkVariantAvailability();
    hideCartRecommendationsForExistingItems();
    installCartActionDelegation();

    // Also respond to some theme events if emitted (optional safety)
    document.addEventListener("cart:updated", updateRecommendationState);
    document.addEventListener("cart:refresh", updateRecommendationState);
    document.addEventListener("cart:change", updateRecommendationState);
  }

  init();
  // 🟩 Expose globally for other scripts (like PDP add-to-cart)
  window.updateRecommendationState = updateRecommendationState;
  window.initCartRecommendationSwiper = initCartRecommendationSwiper;
  window.bindRecommendationAddToCart = bindRecommendationAddToCart;
  window.checkVariantAvailability = checkVariantAvailability;
  window.hideCartRecommendationsForExistingItems = hideCartRecommendationsForExistingItems;
});


// custom cart js ends here









// cart drawer trigger on click of pdp add to cart button starts


// document.addEventListener('DOMContentLoaded', function() {
//   // Find the form containing the button
//   const form = document.querySelector('form[action*="/cart/add"]');
//   if (!form) {
//     console.error('No form found for add to cart');
//     return;
//   }

//   // Prevent default form submission and handle via AJAX
//   form.addEventListener('submit', function(e) {
//     e.preventDefault();
//     e.stopPropagation();

//     // Create FormData from the form
//     const formData = new FormData(form);

//     // Submit via AJAX to /cart/add.js to add product without redirect
//     fetch('/cart/add.js', {
//       method: 'POST',
//       body: formData
//     })
//     .then(response => {
//       if (!response.ok) {
//         throw new Error('Failed to add to cart');
//       }
//       return response.json();
//     })
//     .then(data => {
//       console.log('Product added to cart:', data);

//       // Update cart sections
//       const sectionsToRender = ["cart-drawer", "cart-icon-bubble"];
//       const sectionsUrl = `/?sections=${sectionsToRender.join(",")}`;

//       fetch(sectionsUrl)
//         .then(sectionsRes => {
//           if (!sectionsRes.ok) {
//             throw new Error('Failed to fetch sections');
//           }
//           return sectionsRes.json();
//         })
//         .then(sectionsJSON => {
//           const parsedState = { id: data.id, sections: sectionsJSON };
//           const cartDrawer = document.querySelector("cart-drawer");
//           if (cartDrawer && typeof cartDrawer.renderContents === "function") {
//             cartDrawer.renderContents(parsedState);
//             console.log('[DEBUG] Cart drawer updated');

//             // 🟩 ADD THIS BLOCK HERE
//             setTimeout(() => {
//               if (typeof window.updateRecommendationState === 'function') {
//                 window.updateRecommendationState();
//               } else {
//                 if (typeof window.initCartRecommendationSwiper === 'function') initCartRecommendationSwiper();
//                 if (typeof window.bindRecommendationAddToCart === 'function') bindRecommendationAddToCart();
//                 if (typeof window.checkVariantAvailability === 'function') checkVariantAvailability();
//                 if (typeof window.hideCartRecommendationsForExistingItems === 'function') hideCartRecommendationsForExistingItems();
//               }
//             }, 250);
//             // 🟩 END BLOCK

//           } else {
//             console.warn('CartDrawer not found or invalid.');
//           }

//           // Small delay to ensure update completes, then open drawer
//           setTimeout(() => {
//             const cartIconBubble = document.querySelector('#cart-icon-bubble');
//             if (cartIconBubble) {
//               cartIconBubble.click();
//             } else {
//               console.error('Cart icon bubble not found');
//             }
//           }, 100);
//         })
//         .catch(error => {
//           console.error('Error updating sections:', error);
//         });
//     })
//     .catch(error => {
//       console.error('Error adding to cart:', error);
//       // Fallback: allow default if AJAX fails (will redirect)
//       form.submit();
//     });
//   });
// });


document.addEventListener("DOMContentLoaded", () => {
  const atcKeyframe = document.createElement("style");
  atcKeyframe.textContent = "@keyframes atc-btn-spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}";
  document.head.appendChild(atcKeyframe);

  const addToCartBtns = document.querySelectorAll(".shopify-product-form .latest-add-to-cart-btn");

  if (!addToCartBtns.length) {
    console.warn("[DEBUG] No .latest-add-to-cart-btn buttons found");
    return;
  }

  addToCartBtns.forEach((btn) => {
    btn.addEventListener("click", async (e) => {
      if (btn.hasAttribute("disabled") || btn.getAttribute("aria-disabled") === "true") {
        return;
      }

      const selectedDisabled = !!document.querySelector(
        ".new-product-main .latest-option.active[data-disable='true']"
      );
      const masterselect = document.querySelector("#masterselect");
      const selectedMasterOption = masterselect && masterselect.selectedIndex >= 0
        ? masterselect.options[masterselect.selectedIndex]
        : null;
      const selectedVariantAvailable = selectedMasterOption
        ? selectedMasterOption.getAttribute("data-available") === "true"
        : true;

      if (selectedDisabled) {
        btn.setAttribute("disabled", "disabled");
        return;
      }
      if (!selectedVariantAvailable) {
        btn.setAttribute("disabled", "disabled");
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      console.log("[DEBUG] Add to cart clicked — intercepting form submit");

      btn._originalHTML = btn.innerHTML;
      btn.innerHTML = '<span style="display:inline-block;width:22px;height:22px;border:2px solid rgba(255,255,255,0.4);border-top-color:#fff;border-radius:50%;animation:atc-btn-spin 0.7s linear infinite;"></span>';

      const form = btn.closest("form[action*='/cart/add']");
      if (!form) {
        console.warn("[DEBUG] No form found near button");
        return;
      }

      const formData = new FormData(form);

      try {
        // 1️⃣ Add product to cart manually via AJAX
        const res = await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
        });

        if (!res.ok) throw new Error("Add to cart failed");
        const data = await res.json();
        console.log("[DEBUG] Product added:", data);

        // 2️⃣ Wait until Shopify cart updates (especially for first item)
        const waitForCartUpdate = async (retries = 10) => {
          for (let i = 0; i < retries; i++) {
            try {
              const cartRes = await fetch("/cart.js");
              const cartData = await cartRes.json();
              if (cartData && cartData.item_count > 0) {
                return cartData;
              }
            } catch (err) {
              console.warn("[DEBUG] Retry /cart.js fetch...");
            }
            await new Promise((r) => setTimeout(r, 200));
          }
          return null;
        };

        const cartData = await waitForCartUpdate();
        if (!cartData) throw new Error("Cart did not update");

        // 3️⃣ Refresh cart drawer sections
        const sectionsToRender = ["cart-drawer", "cart-icon-bubble"];
        const sectionsUrl = `/?sections=${sectionsToRender.join(",")}`;
        const sectionRes = await fetch(sectionsUrl);
        const sectionsJSON = await sectionRes.json();

        const parsedState = { id: data.id, sections: sectionsJSON };
        const cartDrawer = document.querySelector("cart-drawer");

        if (cartDrawer && typeof cartDrawer.renderContents === "function") {
          cartDrawer.renderContents(parsedState);
          console.log("[DEBUG] Cart drawer content rendered");
          cartDrawer.classList.remove("is-empty");

          // 4️⃣ Run your recommendation refresh after rendering
          setTimeout(() => {
            if (typeof window.updateRecommendationState === "function") {
              window.updateRecommendationState();
              console.log("[DEBUG] Recommendation refreshed");
            } else {
              if (typeof window.initCartRecommendationSwiper === "function") initCartRecommendationSwiper();
              if (typeof window.bindRecommendationAddToCart === "function") bindRecommendationAddToCart();
              if (typeof window.checkVariantAvailability === "function") checkVariantAvailability();
              if (typeof window.hideCartRecommendationsForExistingItems === "function") hideCartRecommendationsForExistingItems();
            }
          }, 500);
        }

        // 5️⃣ Finally, open the drawer
        setTimeout(() => {
          const cartTrigger = document.querySelector("#cart-icon-bubble");
          if (cartTrigger) {
            cartTrigger.click();
            console.log("[DEBUG] Drawer opened after successful add");
          }
          if (btn._originalHTML) { btn.innerHTML = btn._originalHTML; delete btn._originalHTML; }
        }, 500);
      } catch (err) {
        console.error("[DEBUG] Error adding to cart:", err);
        if (btn._originalHTML) { btn.innerHTML = btn._originalHTML; delete btn._originalHTML; }
      }
    });
  });
});


// cart drawer trigger on click of pdp add to cart button ends








